module.exports = __webpack_public_path__ + "media/src/images/up-icon8-ac25d02da7bc6b5f8d425e361f559fe2.png";